import Vue from 'vue';
import VueRouter from 'vue-router';
import VuexStore from '../store';

// Auth
import SignIn from '../views/SignIn';

// Users
import Users from '../views/Pages/Users/Users';
import NewUser from '../views/Pages/Users/NewUser';

// Couriers
import Couriers from '../views/Pages/Couriers/Couriers';
import NewCourier from '../views/Pages/Couriers/NewCourier';

//Shippers
import Shippers from '../views/Pages/Shippers/Shippers';
import NewShipper from '../views/Pages/Shippers/NewShipper';
import ShippersReceiptManagement from '../views/Pages/ShipperDeliveries/Management';
import ShippersExport from '../views/Pages/Shippers/ShippersExport';
import ShipperInvoices from '../views/Pages/Shippers/ShipperInvoices.vue';

//Exports
import ShipmentsExport from '../views/Pages/Exports/ShipmentsExport';
import ReceiptBackup from '../views/Pages/Exports/ReceiptBackup.vue';
import ReceiptExportPdf from '../views/Pages/Exports/ReceiptExportPdf.vue';
import XmlCteExport from '../views/Pages/Exports/XmlCteExport.vue';
import ShipperXmlCteExport from '../views/Pages/Exports/ShipperXmlCteExport.vue';

//Manifests
import ManifestImport from '../views/Pages/Imports/ManifestImport.vue';
import ManifestImportPreview from '../views/Pages/Imports/ManifestImportPreview.vue';

// Transhipment
import Transhipment from '../views/Pages/Transhipment/Transhipment';
import NewTranshipment from '../views/Pages/Transhipment/NewTranshipment';
import TranshipmentPreview from '../views/Pages/Transhipment/TranshipmentPreview';
import TranshipmentNegotiations from '../views/Pages/Transhipment/TranshipmentNegotiations';
import TranshipmentNegotiationsByID from '../views/Pages/Transhipment/TranshipmentNegotiationsByID';
import NewNegotiation from '../views/Pages/Transhipment/NewNegotiation';
import NewNegotiationWeight from '../views/Pages/Transhipment/NewNegotiationWeight';
import TransferData from '../views/Pages/Transhipment/TranshipmentTransferData';

// Shipments
import Shipments from '../views/Pages/Shipments/Shipments';
import ShipmentsImport from '../views/Pages/Shipments/ShipmentsImport';
import ShipmentsPrint from '../views/Pages/Shipments/ShipmentsPrint';
import ShipmentsReceiptsManagement from '../views/Pages/Shipments/ShipmentsReceiptsManagement';

// Management
import Management from '../views/Pages/Shipments/Management';
import ManagementDetails from '../views/Pages/Shipments/ManagementDetails';

// AccountsPayable
import Aditionals from '../views/Pages/AccountsPayable/AditionalsPage';
import AccountsPayable from '../views/Pages/AccountsPayable/AccountsPayable';
import AccountsPayableTranshipment from '../views/Pages/AccountsPayable/AccountsPayableTranshipment';
import AccountsPayablePaymentOrders from '../views/Pages/AccountsPayable/AccountsPayablePaymentOrders';

// AccountsReceivable
import AditionalsAccountsReceivable from '../views/Pages/AccountsReceivable/AditionalsAccountsReceivable.vue';
import InvoicesAccountsReceivable from '../views/Pages/AccountsReceivable/InvoicesAccountsReceivable.vue';
import ShippersAccountsReceivable from '../views/Pages/AccountsReceivable/ShippersAccountsReceivable.vue';
import Ctes from '../views/Pages/AccountsReceivable/Ctes.vue';
import ImportsXmlCte from '../views/Pages/AccountsReceivable/ImportsXmlCte.vue';
import ImportsXmlNfe from '../views/Pages/ManualBoardingImport/ManualBoarding.vue';
import NfeXmlImportCreation from '../views/Pages/ManualBoardingImport/NfeXmlImportCreation.vue';

// GivBack
import GivBack from '../views/Pages/GivBack/GivBack';

// Quarantine
import Quarantine from '../views/Pages/Quarantine/Quarantine';
import QuarantineTransfer from '../views/Pages/Quarantine/Quarantine-Transfer';
import { Roles } from '@/consts/Roles';
import { hasPermission } from '@/utils/hasPermission';

// Default
import Unauthorized from '@/views/Pages/Default/Unauthorized.vue';

Vue.use(VueRouter);

function checkUserRoutePermissions(to, from) {
  const userRole = VuexStore.getters['LoginStore/getRole'];

  if (from.name === 'SignIn') return true;
  return hasPermission(to.meta.permissions, userRole);
}

const routes = [
  {
    path: '/',
    name: 'SignIn',
    component: SignIn,
    meta: {
      permissions: []
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      permissions: [Roles.ADMIN]
    }
  },
  {
    path: '/users/new',
    name: 'NewUser',
    component: NewUser,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/users/:id',
    name: 'EditUser',
    component: NewUser,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/users/:id/details',
    name: 'ViewUser',
    component: NewUser,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/couriers',
    name: 'Couriers',
    component: Couriers,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/couriers/new',
    name: 'NewCourier',
    component: NewCourier,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/couriers/:id/details',
    name: 'ViewCourier',
    component: NewCourier,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shippers',
    name: 'Shippers',
    component: Shippers,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shippers/new',
    name: 'NewShipper',
    component: NewShipper,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shippers/:id',
    name: 'EditShipper',
    component: NewShipper,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shippers/:id/details',
    name: 'ViewShipper',
    component: NewShipper,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipment-courier/:id/',
    name: 'ViewTranshipmentCourier',
    component: NewCourier,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/couriers/:id',
    name: 'EditCourier',
    component: NewCourier,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments',
    name: 'Transhipment',
    component: Transhipment,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/transfer',
    name: 'TransferData',
    component: TransferData,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations',
    name: 'TranshipmentNegotiations',
    component: TranshipmentNegotiations,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations/:id',
    name: 'TranshipmentNegotiationsByID',
    component: TranshipmentNegotiationsByID,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/:id/:type/details',
    name: 'ViewTranshipment',
    component: TranshipmentPreview,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/new',
    name: 'NewTranshipment',
    component: NewTranshipment,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations/:id/new',
    name: 'NewNegotiation',
    component: NewNegotiation,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations/edit/:type/:id/',
    name: 'EditNegotiation',
    component: NewNegotiation,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations/:id/:type/new-weight',
    name: 'NewNegotiationWeight',
    component: NewNegotiationWeight,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/negotiations/edit-weight/:type/:id/',
    name: 'EditNegotiationWeight',
    component: NewNegotiationWeight,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipments/:id/:type',
    name: 'EditTranshipment',
    component: NewTranshipment,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments',
    name: 'Shipments',
    component: Shipments,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipper-deliveries',
    name: 'ShippersManagement',
    component: ShippersReceiptManagement,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },
  {
    path: '/shipper-deliveries-export',
    name: 'ShipperExport',
    component: ShippersExport,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },
  {
    path: '/shipments/boardingId/:boardingIdFilter',
    name: 'ShipmentsBoardingIdFIlter',
    component: Shipments,
    props: true,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/shipments-import',
    name: 'ShipmentsImport',
    component: ShipmentsImport,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/manifest-import',
    name: 'ManifestImport',
    component: ManifestImport,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/manifest-import-preview/:id/details',
    name: 'ManifestImportPreview',
    component: ManifestImportPreview,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments/export',
    name: 'ShipmentsExport',
    component: ShipmentsExport,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments/print',
    name: 'ShipmentsPrint',
    component: ShipmentsPrint,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments/receipts',
    name: 'ShipmentsReceiptsManagement',
    component: ShipmentsReceiptsManagement,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipper-deliveries/receipts',
    name: 'ShipperDeliveryReceiptManagement',
    component: ShipmentsReceiptsManagement,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },
  {
    path: '/receipts-backup',
    name: 'ReceiptsBackup',
    component: ReceiptBackup,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },
  {
    path: '/receipts-export-image',
    name: 'ReceiptsExport',
    component: ReceiptBackup,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/receipts-export-pdf',
    name: 'ReceiptExportPdf',
    component: ReceiptExportPdf,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipper-invoices',
    name: 'ShipperInvoices',
    component: ShipperInvoices,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },
  {
    path: '/givback',
    name: 'GivBack',
    component: GivBack,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/quarantine',
    name: 'Quarantine',
    component: Quarantine,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/quarantine/transfer',
    name: 'QuarantineTransfer',
    component: QuarantineTransfer,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/couriers-accounts-payable',
    name: 'CouriersAccountsPayable',
    component: AccountsPayable,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/transhipment-accounts-payable',
    name: 'TranshipmentAccountsPayable',
    component: AccountsPayableTranshipment,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/payment-orders',
    name: 'PaymentOrders',
    component: AccountsPayablePaymentOrders,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments/management',
    name: 'Management',
    component: Management,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/shipments/management/details',
    name: 'ManagementDetails',
    component: ManagementDetails,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/financial/aditionals',
    name: 'FinancialAditionals',
    component: Aditionals,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/financial/accounts-receivable/aditionals',
    name: 'AditionalsAccountsReceivable',
    component: AditionalsAccountsReceivable,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/financial/shipper-accounts-receivable',
    name: 'ShippersAccountsReceivable',
    component: ShippersAccountsReceivable,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/financial/accounts-receivable/invoices',
    name: 'InvoicesAccountsReceivable',
    component: InvoicesAccountsReceivable,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/fiscal/ctes',
    name: 'Ctes',
    component: Ctes,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/xml-cte-import',
    name: 'ImportsXmlCte',
    component: ImportsXmlCte,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/manual-boarding-import',
    name: 'ImportsXmlNfe',
    component: ImportsXmlNfe,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/manual-boarding-import/:id/step:step',
    name: 'NfeXmlImportCreation',
    component: NfeXmlImportCreation,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/imports/manual-boarding-import/:id/details',
    name: 'NfeXmlImportDetails',
    component: NfeXmlImportCreation,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/xmls-ctes-export',
    name: 'XmlCteExport',
    component: XmlCteExport,
    meta: {
      permissions: [Roles.ADMIN, Roles.OPERATOR]
    }
  },
  {
    path: '/xmls-export',
    name: 'ShipperXmlCteExport',
    component: ShipperXmlCteExport,
    meta: {
      permissions: [Roles.SHIPPER]
    }
  },

  {
    path: '/unauthorized',
    name: 'UnauthorizedPage',
    component: Unauthorized,
    meta: {
      permissions: []
    }
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (localStorage.getItem('accessToken')) {
    VuexStore.commit('LoginStore/setLogged', true);
    VuexStore.commit('LoginStore/setUserLogged', user);

    if (to.name === 'SignIn') {
      const role = user.userToken.claims[0].value;
      if (role === 'Admin') {
        next({ name: 'Users' });
      } else if (role === 'Operador') {
        next({ name: 'Couriers' });
      } else if (role === 'Embarcador') {
        next({ name: 'ShippersManagement' });
      }
    } else {
      if (checkUserRoutePermissions(to, from)) next();
      else {
        next({ name: 'UnauthorizedPage' });
      }
    }
  } else {
    if (to.name === 'SignIn') {
      next();
    } else {
      next({ name: 'SignIn' });
    }
  }
});

export default router;
